import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { AlarmClock, CalendarDays, Clock, Users } from 'lucide-react';

const TABS = [
  {
    to: '/equipo/personal',
    label: 'Plantilla',
    icon: Users,
    end: true,
    desc: 'Quién hay contratado, en qué puesto y con qué contrato',
  },
  {
    to: '/equipo/personal/ausencias',
    label: 'Ausencias',
    icon: CalendarDays,
    end: false,
    desc: 'Quién falta cada día del mes: vacaciones, bajas y permisos',
  },
  {
    to: '/equipo/personal/fichajes',
    label: 'Fichajes',
    icon: Clock,
    end: false,
    desc: 'Horas, retrasos y días sin fichar, cruzados con las ausencias',
  },
  {
    to: '/equipo/personal/vencimientos',
    label: 'Vencimientos',
    icon: AlarmClock,
    end: false,
    desc: 'Contratos, periodos de prueba y documentos a punto de caducar',
  },
];

/**
 * Agrupa las cuatro vistas de Personal en una sola entrada del menú.
 *
 * La ficha del empleado queda FUERA de este layout a propósito, igual que el
 * detalle de un alojamiento en Reseñas: en un móvil, la cabecera más estas
 * pestañas más las de la ficha se comen media pantalla antes del primer dato.
 */
export default function PersonalLayout() {
  const { pathname } = useLocation();
  const activa = TABS.find((t) => (t.end ? pathname === t.to : pathname.startsWith(t.to))) ?? TABS[0];

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-sereno-blue/50 text-sereno-dark">
          <Users size={22} />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Personal</h1>
          <p className="text-sm text-sereno-dark/50">{activa.desc}</p>
        </div>
      </div>

      <div className="border-b border-slate-200 dark:border-white/10 mb-6">
        <nav className="flex gap-1 -mb-px overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 scrollbar-none">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 sm:px-4 py-3 sm:py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'border-sereno-dark text-sereno-dark font-medium dark:border-white dark:text-white'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
